const days = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

const months = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

export const getCurrentDate = (): string => {
  const today = new Date();
  const dayName = days[today.getDay()];
  const day = today.getDate();
  const monthName = months[today.getMonth()];

  return `${dayName}, ${day} ${monthName}`;
};

export const getCurrentDateLokalised = (): {
  dayKey: string;
  day: number;
  monthKey: string;
} => {
  const today = new Date();
  const dayIndex = today.getDay() === 0 ? 6 : today.getDay() - 1;
  const day = today.getDate();
  const monthIndex = today.getMonth();

  const dayKey = `commons.weekdays.${days[dayIndex]}`;
  const monthKey = `commons.months.${months[monthIndex]}`;

  return { dayKey, day, monthKey };
};

export const getISOCurrentDate = (): string => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

export const getFormattedTimestamp = (timestamp: string | undefined): string => {
  if (!timestamp) return '--';
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return '--';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = String(date.getFullYear()).slice(-2);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} alle ${hours}:${minutes}`;
};